<template>
  <b-row>
    <b-col cols="12" xl="12">  
      <b-card>
        <template slot="header">
          Listado de Resúmenes - {{ tituloFecha }}
        </template> 
        <b-table 
            class="registro"
            responsive
            :no-border-collapse="true"
            :busy="tableBusy"
            :items="resultados" 
            :fields="fields"
            :current-page="paginaActual"
            :per-page="registrosPorPagina">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>
          <template v-slot:cell(fechaCierre)="data">
              {{ data.item.fechaCierre | fecha }}
          </template>
          <template v-slot:cell(fechaVencimiento)="data">
              {{ data.item.fechaVencimiento | fecha }}
          </template>
          <template v-slot:cell(importe)="data">
            {{ data.item.importe | moneda }}
          </template>
          <template v-slot:cell(cerrado)="data">
            {{ data.item.cerrado? 'Si' : 'No' }}
          </template>
          <template v-slot:cell(importeCierre)="data">
            <template v-if="data.item.cerrado">
              {{ data.item.importeCierre | moneda }}
            </template>
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'flujoFondos/getField',
  mutationType: 'flujoFondos/updateField',
});

export default {
  name: 'FlujoFondosTarjetas',
  props: {
    fechaResultados: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'banco',
          label: 'Banco',
        },
        {
          key: 'tarjetaMarca',
          label: 'Tarjeta',
        },
        {
          key: 'numeroCuenta',
          label: 'Nro.Cuenta',
        },
        {
          key: 'fechaCierre',
          label: 'Cierre',
        },
        {
          key: 'fechaVencimiento',
          label: 'Vencimiento',
        },
        {
          key: 'cupones',
          class: 'text-right'
        },
        {
          key: 'importe',
          label: 'Total',
          class: 'text-right'
        },
        {
          key: 'importeCierre',
          label: 'Total Cierre',
          class: 'text-right'
        }
      ],
      
      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'resultados',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
    ]),
    tituloFecha() {
      return moment(this.fechaResultados).format('DD/MM/YYYY');
    }
  },
}
</script>

<style>
</style>
